import { useEffect, useRef } from 'react'
import { Stack } from '@leroy-merlin-br/backyard-react'
import { useDynamicWidgets } from 'react-instantsearch'

import { useAlgoliaContext } from 'site/AlgoliaEntryKey/context/algolia-context'

import { useBodyScrollLock } from 'utils/hooks/use-body-scroll-lock'

import { Header, Footer } from './components'
import * as S from './styled'
import { FilterType } from '../FilterType'
import { SortBy, AppliedFilters } from '../../components'
import { MappedAttributes } from '../../utils/filterToRender'
import { HierarchicalMenu } from '../Filters/components'

interface FiltersMobileProps {
  indexName: string
}

const FiltersMobile = ({ indexName }: FiltersMobileProps) => {
  const { isMobileFilterOpen } = useAlgoliaContext()

  const scrollElement = useRef()

  const [disableScroll, enableScroll, clearAll] = useBodyScrollLock()

  useEffect(() => {
    isMobileFilterOpen
      ? disableScroll(scrollElement?.current)
      : enableScroll(scrollElement?.current)

    return clearAll
  }, [clearAll, disableScroll, enableScroll, isMobileFilterOpen])

  const widgets = useDynamicWidgets()

  return (
    <S.MobileFilters isOpen={isMobileFilterOpen}>
      <Header />
      <S.FiltersContainer ref={scrollElement}>
        <Stack space="bit">
          <SortBy indexName={indexName} />
          <div>
            <AppliedFilters />
            <HierarchicalMenu filterIndex={0} isMobile />

            {widgets.attributesToRender.map((item, index) => (
              <FilterType
                key={`${item}-${index}`}
                attribute={item as MappedAttributes}
                filterIndex={index + 1}
              />
            ))}
          </div>
        </Stack>
      </S.FiltersContainer>
      <Footer />
    </S.MobileFilters>
  )
}

export default FiltersMobile
